<template>
  <div class="ins-main" id="page2019">
    <section class="video-container">
      <div class="viewfix">
        <video controls id="myVideo" @ended="videoEnded" @play="videoPlay" :style="{zIndex: zindex}">
          <source src="https://mov.rollingbet.com/2019Page.cc1a63ea.mp4" type="video/mp4">
          Your browser does not support HTML5 video.
        </video>
      </div>
      <div class="video-cover">
        <div class="title-block" v-if="!zindex">
          <h1 class="font-grey">2019</h1>
          <h1 v-html="$t('lang_themeHeading_page2019VideoTitle')">
          </h1>
          <h3 class="font-grey">
            <span>PAGE</span>
            <span>|</span>
            <i class="icon-fubo"></i>
          </h3>
        </div>
        <div class="play-btn" @click="videoPlay" v-if="!zindex">
          <span class="play-icon"></span>
          <span>PLAY VIDEO</span>
        </div>
        <div class="scroll-down" @click="scrollDown()">
          <span class="arrow-left"></span>
          <span class="arrow-right"></span>
        </div>
      </div>
    </section>
    <section class="exhibition-block" @mousemove="decMoving">
      <div class="exhibition-head">
        <div class="date-mark">
          <div class="date-inner">
            <span>2019</span>
            <p>
              <span>12-14</span>
              <span>JULY</span>
            </p>
          </div>
        </div>
        <div>
          <h2>{{$t('lang_themeHeading_exhibitionSpecial')}}</h2>
          <div class="paragraph">
            <p v-html="$t('lang_exhibition_msg')"></p>
          </div>
        </div>
      </div>
      <div class="exhibition-slider">
        <ul class="pc">
          <carousel :perPage="1" :mouse-drag="false" :navigationEnabled="true"
            :navigationNextLabel="`<span class='icon-arrow-left'></span>`"
            :navigationPrevLabel="`<span class='icon-arrow-left'></span>`" :paginationEnabled="false" :loop="true"
            :autoplay="isCarouselAutoPlay" :speed="1000" :autoplayTimeout="3000">
            <slide v-for="num in 4" :key="num">
              <li>
                <div v-for="( imgs , idx) in exhibitionSliceForPC(num-1)" :key="idx">
                  <img :src='require(`@img/page2019/exhibition/${imgs.smallImg}`)'>
                  <div class="img-hover" @click="setPopImg(imgs.bigImg)">
                    <div class="hover-title">
                      <span>2019 PAGE AISA</span>
                      <span>PHOTO</span>
                    </div>
                  </div>
                </div>
              </li>
            </slide>
          </carousel>
        </ul>
        <ul class="mb">
          <carousel :perPage="1" :mouse-drag="false" :navigationEnabled="true"
            :navigationNextLabel="`<span class='icon-page2019-carousel-btn'></span>`"
            :navigationPrevLabel="`<span class='icon-page2019-carousel-btn'></span>`" :paginationEnabled="false"
            :loop="true" :autoplay="isCarouselAutoPlay" :speed="1000" :autoplayTimeout="3000">
            <slide v-for="num in 5" :key="num">
              <li>
                <div v-for="( imgs , idx) in exhibitionSliceForMB(num-1)" :key="idx">
                  <img :src='require(`@img/page2019/exhibition/${imgs.bigImg}`)'>
                </div>
              </li>
            </slide>
          </carousel>
        </ul>
      </div>
      <img :src="require(`@img/page2019/deco.png`)" class="exhibition-dec pc"
        :style="{left: decPosition.left + 'px',top: (100 + decPosition.top) + 'px'}">
    </section>
    <section class="focus-block">
      <div class="focus-head">
        <div class="date-mark">
          <div class="date-inner">
            <span>2019</span>
            <p>
              <span>PAGE</span>
              <span>ASIA</span>
            </p>
          </div>
        </div>
        <h2>{{$t('lang_themeHeading_exhibitionFocus')}}</h2>
      </div>
      <div class="focus-content">
        <ul class="content-list">
          <li>
            <div>
              <i class="icon-page2019-money"></i>
              <span>{{$t('lang_exhibitionFocus_list3_title')}}</span>
            </div>
            <div>
              <p v-html="$t('lang_exhibitionFocus_list3_msg')"></p>
              <button @click="switchRoute('payment')">LEARN MORE</button>
            </div>
          </li>
          <li>
            <div>
              <i class="icon-page2019-web"></i>
              <span v-html="$t('lang_men_platformSolution')"></span>
            </div>
            <div>
              <p v-html="$t('lang_exhibitionFocus_list2_msg')"></p>
              <button @click="switchRoute('rbcn')">LEARN MORE</button>
            </div>
          </li>
          <li>
            <div>
              <i class="icon-page2019-game"></i>
              <span>{{$t('lang_exhibitionFocus_list4_title')}}</span>
            </div>
            <div>
              <p v-html="$t('lang_exhibitionFocus_list4_msg')"></p>
              <button @click="switchRoute('gamelobby')">LEARN MORE</button>
            </div>
          </li>
        </ul>
      </div>
    </section>
    <section class="marquee-block">
      <div class="platform_display-inner" @mouseenter="stop" @mouseleave="run">
        <ul>
          <marquee-text :paused="isMarquee" :duration="30">
            <li v-for="(logo,index) in footerLogo" :key="index">
              <img :src='require(`@img/${logo.img}`)'>
            </li>
          </marquee-text>
        </ul>
      </div>
    </section>
    <div class="img-popup" v-if="isPopUp">
      <div class="popup-content">
        <img :src="require(`@img/page2019/exhibition/${popImg}`)">
        <span class="pop-close" @click="popClose()">X</span>
      </div>
    </div>
  </div>
</template>
<script>
import $ from 'jquery'
import exhibition from '@data/exhibition2019'
import { Carousel, Slide } from 'vue-carousel'
import MarqueeText from 'vue-marquee-text-component'
import { mapGetters } from 'vuex'

export default {
  name: 'G2EAsia2019',
  data() {
    return {
      zindex: 0,
      video: null,
      isMarquee: false,
      exhibitions: exhibition,
      isPopUp: false,
      popImg: null,
      decPosition: {
        left: 0,
        top: 0
      },
      isCarouselAutoPlay: true
    }
  },
  components: {
    MarqueeText,
    Carousel,
    Slide
  },
  computed: {
    ...mapGetters({
      defLangx: 'defLangx',
      nowLangx: 'nowLangx',
    }),
    footerLogo() {
      return[
        {
          img: 'footer_bb.png'
        },{
          img: 'footer_pt.png'
        },{
          img: 'footer_ab.png'
        },{
          img: 'footer_188.png'
        },{
          img: 'footer_ag.png'
        },{
          img: 'footer_cmd.png'
        },{
          img: 'footer_ea.png'
        },{
          img: 'footer_gd.png'
        },{
          img: 'footer_gg.png'
        },{
          img: 'footer_jdb.png'
        },{
          img: 'footer_mg.png'
        },{
          img: 'footer_ow.png'
        },{
          img: 'footer_sg.png'
        },{
          img: 'footer_sunbet.png'
        },{
          img: 'footer_tgp.png'
        },{
          img: 'footer_n2.png'
        },{
          img: 'footer_cq9.png'
        },{
          img: 'footer_bg.png'
        }
      ]
    },
  },
  methods:{
    videoEnded() {
      this.zindex = 0
    },
    videoPlay() {
      this.video.play()
      this.zindex = 1
    },
    stop(){
      this.isMarquee = true
    },
    run(){
      this.isMarquee = false
    },
    exhibitionSliceForPC(i) {
      if(i === 0){
        return this.exhibitions.slice(i,5)
      }
      return this.exhibitions.slice(i * 5,i * 5 + 5)
    },
    exhibitionSliceForMB(i) {
      if(i === 0){
        return this.exhibitions.slice(i,4)
      }
      return this.exhibitions.slice(i * 4,i * 4 + 4)
    },
    setPopImg(img) {
      const body = document.getElementsByTagName('body')
      body[0].classList.add('noscroll')
      this.isPopUp = true
      this.popImg = img
      this.isCarouselAutoPlay = false
      this.stop()
    },
    popClose() {
      const body = document.getElementsByTagName('body')
      body[0].classList.remove('noscroll')
      this.isPopUp =false
      this.popImg = null
      this.isCarouselAutoPlay = true
      this.run()
    },
    decMoving(e) {
      const view=e.view
      const { screenX: x, screenY: y } = e
      const {innerWidth:w,innerHeight:h}=view
      const xRate=x/w
      const yRate=y/h
      this.decPosition.left = -100 * xRate
      this.decPosition.top = -100 * yRate
    },
    switchRoute(path) {
      this.$router.push({
        path
      })
    },
    scrollDown() {
      $(function() {
        $('html,body').animate({scrollTop: 500}, 200)
      })
    }
  },
  mounted() {
    this.video = document.getElementById('myVideo')
    this.$store.dispatch('setLoadshow',false)
  },
  beforeDestroy(){
    this.$store.dispatch('setLoadshow',true)
  }
}
</script>

<style lang="sass">
  @import '@css/page2019.sass'
</style>